class ActivityMegaMenu extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('.mega-menu__activity-image');
    this.titleEl = this.querySelector('.mega-menu__activity-image-title');
    this.links = this.querySelectorAll('.mega-menu__activity-link');

    this.defaultImage = this.dataset.defaultImage || '';
    this.defaultAlt = this.dataset.defaultAlt || '';

    if (this.image) {
      this.defaultSrc = this.image.currentSrc || this.image.src;
      this.defaultSrcset = this.image.getAttribute('srcset') || '';
    }

    this.reset();

    this.links.forEach((link) => {
      link.addEventListener('mouseenter', () => this.showHover(link));
    });

    this.addEventListener('mouseleave', () => this.reset());

    const details = this.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (!details.open) this.reset();
      });
    }
  }

  showHover(link) {
    const imageUrl = link.dataset.activityImage;
    const title = link.dataset.activityTitle;

    if (imageUrl && this.image) {
      this.image.src = imageUrl;
      this.image.srcset = '';
      this.image.alt = title || '';
    }

    if (this.titleEl) {
      if (title) {
        this.titleEl.textContent = title.toUpperCase();
        this.titleEl.classList.add('is-visible');
      } else {
        this.titleEl.textContent = '';
        this.titleEl.classList.remove('is-visible');
      }
    }
  }

  reset() {
    if (this.image) {
      if (this.defaultSrc) {
        this.image.src = this.defaultSrc;
      } else if (this.defaultImage) {
        this.image.src = this.defaultImage;
      }

      if (this.defaultSrcset) {
        this.image.srcset = this.defaultSrcset;
      } else {
        this.image.removeAttribute('srcset');
      }

      this.image.alt = this.defaultAlt;
    }

    if (this.titleEl) {
      this.titleEl.textContent = '';
      this.titleEl.classList.remove('is-visible');
    }
  }
}

customElements.define('activity-mega-menu', ActivityMegaMenu);
